var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLoggedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.789 15.4554C4.95334 16.0772 4.41494 16.8387 4.18917 17.6382C2.23164 15.8836 1 13.3356 1 10.4998C1 5.20711 5.2906 0.916504 10.5833 0.916504C15.8761 0.916504 20.1667 5.20711 20.1667 10.4998C20.1667 13.3366 18.9342 15.8854 16.9754 17.6401C16.75 16.8399 16.2114 16.0776 15.3751 15.4554C12.7519 13.5149 8.43144 13.5149 5.789 15.4554ZM10.372 12C10.4573 11.9893 10.5534 11.9893 10.628 12C12.5061 11.9359 13.9893 10.3969 14 8.50534C14 6.57099 12.4314 5 10.5 5C8.55793 5 7 6.57099 7 8.50534C7 10.3969 8.4939 11.9359 10.372 12Z",
    fill: "#0008C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 20.0832C15.794 20.0832 20.0846 15.7926 20.0846 10.4998C20.0846 5.20711 15.794 0.916504 10.5013 0.916504C5.20857 0.916504 0.917969 5.20711 0.917969 10.4998C0.917969 15.7926 5.20857 20.0832 10.5013 20.0832Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLoggedIn);
export default __webpack_public_path__ + "static/media/profileLoggedIn.d840ec7b2cdf40aa33f40cbfc19d1d88.svg";
export { ForwardRef as ReactComponent };